function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "cancel_16"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}), /*#__PURE__*/React.createElement("path", {
  d: "M8,6.72720779 L11.46361,3.26359779 C11.8150819,2.91212593 12.3849303,2.91212593 12.7364022,3.26359779 C13.0878741,3.61506966 13.0878741,4.18491814 12.7364022,4.53639 L9.27279221,8 L12.7364022,11.46361 C13.0878741,11.8150819 13.0878741,12.3849303 12.7364022,12.7364022 C12.3849303,13.0878741 11.8150819,13.0878741 11.46361,12.7364022 L8,9.27279221 L4.53639,12.7364022 C4.18491814,13.0878741 3.61506966,13.0878741 3.26359779,12.7364022 C2.91212593,12.3849303 2.91212593,11.8150819 3.26359779,11.46361 L6.72720779,8 L3.26359779,4.53639 C2.91212593,4.18491814 2.91212593,3.61506966 3.26359779,3.26359779 C3.61506966,2.91212593 4.18491814,2.91212593 4.53639,3.26359779 L8,6.72720779 Z",
  id: "Mask",
  fill: "currentColor",
  fillRule: "nonzero"
})));

var Svg16Cancel = function Svg16Cancel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg16Cancel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/16_cancel.7ed03449.svg";
export { ForwardRef as ReactComponent };